module.exports = __webpack_public_path__ + "static/img/1.1e54a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/1.png
// module id = IG1B
// module chunks = 0